<template>
  <div ref="table"></div>
</template>

<script>
import Tabulator from 'tabulator-tables';
import 'tabulator-tables/dist/css/tabulator_midnight.min.css';
import cdata from '../assets/coderaw.json';
import chargeMaster from '../assets/chargemaster.json';

const ageTator = function(dobin){
        let out;
        if(dobin && dobin.includes("/")){
          let dobarr = dobin.split("/"),
            dob = new Date(dobarr[2],dobarr[0],dobarr[1]),
            diff = Date.now() - dob.getTime(),
            age = new Date(diff);
          out = Math.abs(age.getUTCFullYear() - 1970);
        }else{
          out = null;
        }
        return out
      };

export default{
  name: 'HelloWorld',
    data: function () {
      return {
        tabulator: null, //variable to hold your table
        tableData: cdata,
        chargeMaster: chargeMaster,
        rd:{},
        codeColumns: [
          {rowHandle:true, formatter:"handle", headerSort:false, frozen:true, width:30, minWidth:30},
          {
              title: "Status",
              field: "status",
              editor: "select",
              editorParams: {
                  values: ["NEW", "IN PROGRESS", "COMPLETE"]
              }
          }, {
              title: "Encounter ID",
              field: "encounter_id"
          }, {
              title: "DOS",
              field: "dos"
          }, {
              title: "Location",
              field: "location",
              editor: "select",
              editorParams: {
                  values: true
              }
          }, 
          // {
          //     title: "Patient Demographics",
          //     columns:
          //     [{
          //             title: "MRN",
          //             field: "mrn"
          //         }, {
          //             title: "Name",
          //             field: "patient"
          //         }, {
          //             title: "Sex",
          //             field: "sex"
          //         }, 
          //         {
          //             title: "Age",
          //             field: "age",
          //             mutator: this.ageTator
          //         }, 
          //         {
          //             title: "DOB",
          //             field: "dob"
          //         },
          //     ]
          // }, 
          {
              title: "Encounter Info",
              columns:
              [{
                      title: "Payer",
                      field: "payer",
                      editor: "select",
                      editorParams: {
                          values: true
                      }
                  }, {
                      title: "Provider",
                      field: "provider",
                      editor: "select",
                      editorParams: {
                          values: true
                      }
                  }, {
                      title: "Encounter Summary",
                      field: "encounter_summary",
                      editor: "textarea",
                      editorParams: {
                          verticalNavigation: "editor"
                      }
                  }
              ]
          }, {
              title: "Codes",
              columns: [{
                      title: "Code Set",
                      field: "code_set",
                      editor: "select",
                      editorParams: {
                          values: ["em", "cpt", "icd", "hcpcs", "dx"],
                          verticalNavigation: "editor"
                      }
                  }, {
                      title: "Code",
                      field: "code", editor:"autocomplete", editorParams:{allowEmpty:true, showListOnEmpty:true, values:true}
                  }, {
                      title: "Description",
                      field: "description",
                      mutator: this.codeLookup,
                      mutatorParams: {
                          field: "description"
                      }
                  }, {
                      title: "Qty",
                      field: "qty",
                      editor: "number",
                      editorParams: {
                          min: 1,
                          max: 20,
                          step: 1,
                          verticalNavigation: "editor",
                      }
                  }, {
                      title: "Charge",
                      field: "charge",
                       formatter:"money", 
                       formatterParams:{
                          decimal:".",
                          thousand:",",
                          symbol:"$",
                          symbolAfter:"",
                          precision:2,
                      },
                      mutator: this.codeLookup,
                      mutatorParams: {
                          field: "charge"
                      }
                  }, {
                      title: "Mods",
                      field: "mods",
                      editor: "select",
                      editorParams: {
                          values: ["22", "25", "57", "24", "59", "79", "GA", "LT"],
                          verticalNavigation: "editor",
                          multiselect: true,
                      }
                  }
              ]
          }, {
              title: "Rationale Note",
              field: "rationale_note",
              editor: "textarea",
              editorParams: {
                  verticalNavigation: "editor"
              }
          }
        ]
      }
    },
    watch:{
      //update table if data changes
      tableData:{
        handler: function (newData) {
          this.tabulator.replaceData(newData);
          let nlen = newData.length,clen=0;
          for(let n=0; n<nlen; n++){
            clen += (newData[n].status == "COMPLETE" ? 1 : 0);
          }
          // console.log(Math.round((clen/nlen)*100));
          this.$root.cLen = clen;
          this.$root.nLen = nlen;
          this.$root.perComplete = Math.round((clen/nlen)*100);
        },
        deep: true,
      }
    },
    mounted(){
      let nlen = cdata.length,clen=0;
          for(let n=0; n<nlen; n++){
            clen += (cdata[n].status == "COMPLETE" ? 1 : 0);
          }
          // console.log(Math.round((clen/nlen)*100));
          this.$root.cLen = clen;
          this.$root.nLen = nlen;
          this.$root.perComplete = Math.round((clen/nlen)*100);
      this.tabulator = new Tabulator(this.$refs.table, {
        data: this.tableData,
        height:'100%',
        reactiveData:true,
        history:true,
        layout:"fitDataFill",
        columns: this.codeColumns,
        groupBy:["encounter_id", "dos"],
        groupStartOpen:[true,true],
        groupHeader:[
            function(value, count, data, group){
              // // console.log(value);
              // // console.log(count);
              // // console.log(JSON.stringify(this.rd));
              // // console.log(group._group.groupList[0].rows[0].data);
              let d = group._group.groupList[0].rows[0].data;
                return value + " - Name: " + d.patient + " | MRN: " + d.mrn + " | DOB: " + d.dob + " | Age: " + ageTator(d.dob);
            },
            function(value, count, data){
                // // console.log(value);
                // // console.log(count);
                // // console.log(JSON.stringify(data));
                //this.rd=data;
                return value;
            },
        ],
        movableRows:true,
      });
    },
    methods:{
      codeLookup(value, data, type, params, component){
        let code = data.code,out="";
        if(this.chargeMaster[code]){
          out = this.chargeMaster[code][params.field];
        }
        return out;
      },
      // ageTator(dobin){
      //   let out;
      //   if(dobin && dobin.includes("/")){
      //     let dobarr = dobin.split("/"),
      //       dob = new Date(dobarr[2],dobarr[0],dobarr[1]),
      //       diff = Date.now() - dob.getTime(),
      //       age = new Date(diff);
      //     out = Math.abs(age.getUTCFullYear() - 1970);
      //   }else{
      //     out = null;
      //   }
      //   return out
      // }
      // ageTator(value, data, type, params, component){
      //   let out;
      //   if(data && data.dob.includes("/")){
      //     let dobarr = data.dob.split("/"),
      //       dob = new Date(dobarr[2],dobarr[0],dobarr[1]),
      //       diff = Date.now() - dob.getTime(),
      //       age = new Date(diff);
      //     out = Math.abs(age.getUTCFullYear() - 1970);
      //   }else{
      //     out = null;
      //   }
      //   return out
      // }
    }
  };
</script>

<style>
  .tabulator-row .tabulator-cell.tabulator-row-handle .tabulator-row-handle-box .tabulator-row-handle-bar {
    background: white !important;
  }
  .tabulator-edit-select-list .tabulator-edit-select-list-item.active {
    color:limegreen !important;
}
</style>